var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApiError',{attrs:{"home-route":_vm.homeRoute}},[_c('MainLogo',{attrs:{"slot":"brand"},slot:"brand"}),_c('PageFooter',{attrs:{"slot":"footer"},slot:"footer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }